module.exports = __webpack_public_path__ + "static/tr-2-f0edb3c7c73f715239fc30679c806f63.jpg";